import { CountryCode, getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js'
import { useMemo, useState } from 'react'
import TextField from './TextField'

const flag = (cc: string) => String.fromCodePoint(...[...cc].map((c) => 0x1f1a5 + c.charCodeAt(0)))

// Emits E.164 ("+60123456789") via onChange; the server keeps digits only.
export default function PhoneField({ label, name, error, required, onChange }: {
  label: string
  name: string
  error?: string
  required?: boolean
  onChange: (e164: string) => void
}) {
  const regionNames = useMemo(() => new Intl.DisplayNames(['en'], { type: 'region' }), [])
  const countries = useMemo(
    () => getCountries().map((cc) => ({ cc, name: regionNames.of(cc) ?? cc })).sort((a, b) => a.name.localeCompare(b.name)),
    [regionNames],
  )
  const [country, setCountry] = useState<CountryCode>('MY')
  const [national, setNational] = useState('')

  const emit = (cc: CountryCode, value: string) => {
    const parsed = parsePhoneNumberFromString(value, cc)
    onChange(parsed?.number ?? (value ? `+${getCountryCallingCode(cc)}${value.replace(/\D/g, '').replace(/^0/, '')}` : ''))
  }

  return (
    <TextField
      label={label}
      name={name}
      error={error}
      required={required}
      type="tel"
      inputMode="tel"
      autoComplete="tel-national"
      placeholder="12 345 6789"
      value={national}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '')
        setNational(digits)
        emit(country, digits)
      }}
    >
      <span className="ho-prefix-wrap">
      <span className="ho-prefix-view" aria-hidden="true">{flag(country)} +{getCountryCallingCode(country)}</span>
      <select
        className="ho-prefix"
        aria-label="Country code"
        value={country}
        onChange={(e) => {
          const cc = e.target.value as CountryCode
          setCountry(cc)
          emit(cc, national)
        }}
      >
        {countries.map(({ cc, name: n }) => (
          <option key={cc} value={cc}>
            {flag(cc)} +{getCountryCallingCode(cc)} {n}
          </option>
        ))}
      </select>
      </span>
    </TextField>
  )
}
